import { useSelector } from "react-redux";
import RecurringSubs from "../../components/recurring-subscriptions/RecurringSubs";
import { selectUser } from "../../components/auth/auth.selector";

const RecurringSubscriptions = () => {
  const userInfoData = useSelector(selectUser);

  return <RecurringSubs userInfoData={userInfoData} />;
};

export default RecurringSubscriptions;
